/**
 * English (GBP) mock rows for the CSV-import review mockup. Shapes mirror the
 * app's import preview rows (see web/src/screens/transactions/transaction-import/).
 */

/**
 * @typedef {Object} MockImportRow
 * @property {string} date
 * @property {string} type
 * @property {number} amount
 * @property {string} description
 * @property {boolean} included
 * @property {string[]} errors
 * @property {boolean} isDuplicate
 * @property {'existing'|'existing-possible'} [reason]
 */

/** @type {Array<MockImportRow>} */
export const MOCK_IMPORT_ROWS_EN = [
	{ date: '2026-07-30', type: 'Withdrawal', amount: 12000, description: 'Convenience store', included: true, errors: [], isDuplicate: false },
	{ date: '2026-07-29', type: 'Purchase', amount: 4800, description: 'Coffee shop', included: true, errors: [], isDuplicate: false },
	{ date: '2026-07-25', type: 'Deposit', amount: 350000, description: 'Salary', included: true, errors: [], isDuplicate: false },
	{ date: '2026-07-22', type: 'Purchase', amount: 4830, description: 'Convenience store', included: false, errors: [], isDuplicate: true, reason: 'existing' },
	{ date: '2026-07-18', type: 'Reward Earned', amount: 4200, description: 'Flight bonus', included: false, errors: [], isDuplicate: true, reason: 'existing-possible' },
	{ date: '2026-07-12', type: '', amount: 20000, description: 'ATM cash', included: false, errors: ['type'], isDuplicate: false },
];
